/**
 * Public site brand filters — must match Brand rows in tenant DB (slug or name).
 * Override via .env if your slugs differ.
 */
export const PUBLIC_BRAND_STAYJADE =
  process.env.REACT_APP_PUBLIC_BRAND_STAYJADE || 'stayjade';

/** DB slug is often `redolive` (no hyphen) — keep both query forms working via listingBranding. */
export const PUBLIC_BRAND_RED_OLIVE =
  process.env.REACT_APP_PUBLIC_BRAND_RED_OLIVE || 'redolive';
